import "./LabInformationAndContactDetailsComponent.scss";
import React, {useCallback, useEffect, useState} from "react";
import LabInformationAndContactDetailsViewComponent
    from "./lab-information-and-contact-details-view/LabInformationAndContactDetailsViewComponent";
import LabInformationAndContactDetailsEditComponent
    from "./lab-information-and-contact-details-edit/LabInformationAndContactDetailsEditComponent";

interface LabInformationAndContactDetailsComponentProps {
    labDetails: any;
    onUpdateLabInformation: Function;
    onModeChange:Function;
    canEdit: boolean;
}

const LabInformationAndContactDetailsComponent = (props: LabInformationAndContactDetailsComponentProps) => {

    const {labDetails, onUpdateLabInformation,onModeChange,canEdit} = props;
    const [mode, setMode] = useState<"view" | "edit">("view");
    const [labBasicDetails, setLabBasicDetails] = useState<any>(undefined);

    const handleLabBasicDetailsUpdate = useCallback((updatedLabDetails: any) => {
        onUpdateLabInformation(updatedLabDetails);
        onModeChange("view");
        setMode("view");
    }, [onUpdateLabInformation,onModeChange]);

    const handleLabBasicDetailsEditCancel = useCallback(() => {
        onModeChange("view");
        setMode("view");
    }, [onModeChange]);

    useEffect(() => {
        if (labDetails) {
            setLabBasicDetails(labDetails);
        }
    }, [labDetails]);

    useEffect(()=>{
        onModeChange(mode);
    },[mode,onModeChange])

    return (
        <div className="lab-information-and-contact-details-component details-tab-data-wrapper">
            {
                mode === "view" && <LabInformationAndContactDetailsViewComponent
                    labDetails={labBasicDetails}
                    canEdit={canEdit}
                    onEditModeOpen={() => {
                        setMode("edit")
                    }}
                />
            }
            {
                mode === "edit" && <LabInformationAndContactDetailsEditComponent labDetails={labBasicDetails}
                                                            onUpdateComplete={handleLabBasicDetailsUpdate}
                                                            onEditCancel={handleLabBasicDetailsEditCancel}
                />
            }
        </div>
    );

};

export default LabInformationAndContactDetailsComponent;